/***
 * Created on 2023/7/14
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useRef, useState} from 'react';
import {handleInputValidationError} from "common/ServiceCommon";
import {useTranslation} from "react-i18next";

function TextInput(props) {
    const { t } = useTranslation();
    const {label, required, onChange, compType='', ..._props} = props;
    const inputRef = useRef();
    const isDirty = useRef(false);
    const [valid, setValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState();

    const onInputChange = (e) => {
        // this is a way to escape initial validation check on html5 form
        if (required) {
            inputRef.current.setAttribute('required', true);
        }

        if (typeof onChange === 'function') {
            onChange(e, () => {
                isDirty.current = true;
            });
        }
        else {
            isDirty.current = true;
        }
    }

    useEffect(() => {
        setValid(inputRef?.current?.checkValidity());
        setErrorMessage(handleInputValidationError(t, inputRef.current));
    }, [props.value]);

    return (
        <div className={`${compType==='dialog' ? 'dialog__' : ''}form-group`}>
            <label className={required ? 'required' : ''}>{label || ""}</label>
            <div className="form-group__field">
                <input type="text"
                       {..._props}
                       // required={required}
                       ref={inputRef}
                       onChange={onInputChange}
                       className={`${props.className} ${isDirty.current && !valid ? 'input--invalid' : ''}`}/>
                {!valid && <div className="text-error text-14 mt-10">{errorMessage}</div>}
            </div>
        </div>
    );
}

export default TextInput;